<div class="allcp-form theme-primary mw320" id="password">
	<div class="panel mw320" style="background: #fff">
		<div class="panel-heading pn">
            <div class="panel-title">New Password</div>
        </div>
	    <form method="post" id="passwordForm" ng-submit="password(passwordForm)">
	        <input type="hidden" name="_token" value="<% csrf_token() %>" />
	        <div class="panel-body pn mv10">
	            <div class="section">
	                <label for="password" class="field">
	                    <input type="password" name="password" id="password" class="gui-input" placeholder="Password..." ng-model="passwordForm.password" required>
	                </label>
	            </div>
	            <div class="section">
	                <label for="password_repeat" class="field">
	                    <input type="password" name="password_repeat" id="password_repeat" class="gui-input" placeholder="Repeat Password..." ng-model="passwordForm.password_repeat" required>
	                </label>
	            </div>
	            <div class="section">
	                <button type="submit" id="passwordSubmit" class="btn ladda-button btn-block btn-bordered btn-primary pull-right" data-style="expand-right" id="passwordButton">
	                    <span class="ladda-label">Reset</span>
	                    <span class="ladda-spinner"></span><span class="ladda-spinner"></span>
	                </button>
	            </div>
	        </div>
	    </form>
	</div>
</div>